'use strict'
//master
const prov_erp = 'https://admin.diandangquan.net'
// const prov_erp = 'https://admin-t.diandangquan.net'
const prov = 'https://identify.renrenshe.com'
// const prov = 'http://192.168.15.186:14000' //开发

const fileProv = 'https://app.diandangquan.net'

export default {
	ccic_bj:prov + '/api/external/identify_cert/qrcode',
	all_subject_student:prov + '/api/external/all-subject-student/certNumber',
	resetPassword: prov + '/api/user/reset_password',//修改密码
	wx_apply:prov + '/api/identify/wx-user/apply',
	wx_login:prov + '/api/identify/wx-user/login',
	identify_search:prov + '/api/identify/big-data/search',
	identify:prov + '/api/identify/big-data',
	expires:8*60*1000,
	brandGroup: prov_erp + '/api/brand_group',//品牌分组
	goodsCategory: prov_erp + '/api/goods_category',//商品分类
	category:prov_erp + '/api/service/category',
	brand: prov_erp + '/api/brand',//品牌管理
	goodsSerial: prov_erp + '/api/goods_serial',//商品系列管理
	goodsType: prov_erp + '/api/goods_type',//商品类型管理
	certNumber:prov +'/api/external/identify_cert/certNumber',//////证书编号
	login: prov + '/api/login',//登录
	current: prov + '/api/user/current',//当前登录人
	user: prov + '/api/user',//用户管理
	identifyId:prov +'/api/external/identify_cert/identifyId',  //////鉴定ID
	sts_token:prov + '/api/oss/sts_token',
	url:prov,
	thumb: fileProv + '/api/image/thumb',//获取缩略图
	file: fileProv + '/api/image',//文件接口
	logout: prov + '/api/logout',//退出
	brand: prov_erp + '/api/service/brand',//品牌管理
    getCustomer:prov +'/api/customer',
    appraiser:prov + '/api/external/identify-appraiser/certNumber',
    dict:prov + '/api/dict',
	appraiser_gd: prov + '/api/external/identify-appraiser/simple',
    byIdentifyId :prov +'/api/identify/record/identifyId',
	cert:prov + '/api/identify/cert',
}



// WEBPACK FOOTER //
// ./src/util/api.js